export default __webpack_public_path__ + "static/media/request.8ebf930f.svg";